import TextOptionsQuestionTemplate from '~/pages/anatomyV2/libs/components/TextOptionsQuestionTemplate'
import { TEXT_OPTIONS_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/textOptionsCorrectAnswers'
import {
  neckStrainPNG,
  neckStrainWEBP,
} from '~/pages/anatomyV2/neckStrain/constants'
import { PageId } from '~/shared/constants/pagesConstants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 4

const OPTIONS = [
  { key: 'phone', i18nKey: 'onboarding.neckStrain.options.phone' },
  { key: 'sleeping', i18nKey: 'onboarding.neckStrain.options.sleeping' },
  { key: 'bag', i18nKey: 'onboarding.neckStrain.options.bag' },
]

const NeckStrainAnatomyV2 = (props: TPageProps) => (
  <TextOptionsQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.neckStrain.title"
    questionImagePNG={neckStrainPNG}
    questionImageWEBP={neckStrainWEBP}
    questionImageAlt="Neck strain"
    options={OPTIONS}
    correctOptionKey={
      TEXT_OPTIONS_CORRECT_ANSWERS[PageId.NECK_STRAIN_ANATOMY_V2_1]!
    }
    correctTitleI18nKey="onboarding.neckStrain.correctTitle"
    correctExplanationI18nKey="onboarding.neckStrain.correctExplanation"
    incorrectTitleI18nKey="onboarding.neckStrain.incorrectTitle"
    incorrectExplanationI18nKey="onboarding.neckStrain.incorrectExplanation"
    question="What adds the most strain to your neck"
  />
)

export default NeckStrainAnatomyV2
